import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const MerchantContext = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

export function MerchantProvider({ children }) {
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchMe = useCallback(async (redirect = true) => {
    try {
      const { data } = await axios.get(`${API}/api/v1/merchant/me`, { withCredentials: true });
      setMerchant(data);
      return data;
    } catch {
      if (redirect) navigate("/login");
      return null;
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const logout = async () => {
    await axios.post(`${API}/api/v1/merchant/logout`, {}, { withCredentials: true }).catch(() => {});
    setMerchant(null);
    navigate("/login");
  };

  const switchMode = async (mode) => {
    const { data } = await axios.put(`${API}/api/v1/merchant/mode`, { mode }, { withCredentials: true });
    await fetchMe(false);
    return data;
  };

  return (
    <MerchantContext.Provider value={{ merchant, loading, fetchMe, logout, switchMode }}>
      {children}
    </MerchantContext.Provider>
  );
}

export const useMerchant = () => useContext(MerchantContext);
export default MerchantContext;
